import { Injectable } from '@angular/core';
import { ProjectContactDirectory } from 'src/app/_model/project-contact-directory';
import { Resetable } from '../../resetter/resetable';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export abstract class ProjectContactDirectoryDaoService implements Resetable {
  public abstract saveProjectContactDirectory(entries: ProjectContactDirectory[]): Promise<void>;
  public abstract createProjectContactDirectory(entry: ProjectContactDirectory): Promise<ProjectContactDirectory>;
  public abstract deleteLocalProjectContactDirectory(id: IMSId): Promise<void>;
  public abstract deleteSyncedProjectContactDirectory(id: IMSId): Promise<void>;
  public abstract getProjectContactDirectory(): Promise<ProjectContactDirectory[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
